import { toast } from "react-toastify";
import AuthServices from "../../services/authServices";
import { authConstant } from "../constants/authConstants";

export const login = (payload, navigate, Cookies, setLoading) => (dispatch) => {
  AuthServices.login(payload)
    .then((data) => {
      dispatch({
        type: authConstant.LOGIN_SUCCESS,
        payload: data.data,
      });
      if (data.status) {
        setLoading(false);
        Cookies.set("jwt_token", data.data.token, { expires: 1 });
        //sakshi added
        localStorage.setItem("jwt_token", JSON.stringify(data.data.token));
        navigate("/user/viewprofile");
        toast.success("Login Success", {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: false,
        });
      } else {
        setLoading(false);
        toast.error("Login Failed", {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: false,
        });
      }
    })
    .catch((err) => {
      setLoading(false);
      dispatch({
        type: authConstant.LOGIN_FAILED,
        payload: err,
      });
    });
};
export const register = (payload, history, setLoading) => (dispatch) => {
  AuthServices.register(payload)
    .then((data) => {
      dispatch({
        type: authConstant.REGISTER_SUCCESS,
        payload: data.data,
      });
      if (data.status) {
        setLoading(false);
        history.push("/user/login");
        console.log(data);
        toast.success(data.message, {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: false,
        });
      } else {
        setLoading(false);
        toast.error(data.message, {
          position: "top-center",
          autoClose: 5000,
          pauseOnHover: false,
        });
      }
    })
    .catch((err) => {
      setLoading(false);
      dispatch({
        type: authConstant.REGISTER_FAILED,
        payload: err,
      });
    });
};
